import { render, staticRenderFns } from "./GetResetPassword.vue?vue&type=template&id=c023c88e&"
import script from "./GetResetPassword.vue?vue&type=script&lang=ts&"
export * from "./GetResetPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports